import * as React from "react";
import { Index, Configure } from "react-instantsearch";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
const FilteredIndex = ({
  index,
  hitsPerPage,
  hasAnalytics = false,
  children
}) => {
  const { locale } = useIntl();
  const { isMultilingualEnabled } = useFeatureToggles();
  const localeFilter = `locale:${locale.replace("-", "_")}`;
  const filtersWithLocaleCheck = index.filters ? `${localeFilter} AND (${index.filters})` : localeFilter;
  const filters = isMultilingualEnabled && index.type === "content" ? filtersWithLocaleCheck : index.filters;
  return /* @__PURE__ */ React.createElement(Index, { indexName: index.name }, /* @__PURE__ */ React.createElement(Configure, { filters, analytics: hasAnalytics, offset: 0, length: hitsPerPage }), children);
};
export {
  FilteredIndex
};
//# sourceMappingURL=FilteredIndex.js.map
